import { render } from "./categoryheader.vue?vue&type=template&id=48ca62ac"
import script from "./categoryheader.vue?vue&type=script&lang=js"
export * from "./categoryheader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__